const Hero = () => {
    return (
        <section className="hero">
            <div className="hero-overlay">
                <h1>Innovate.<br></br>Build. Scale.</h1>
                <p>Your Business, Powered by AI and <br></br>Collaboration.</p>
                <div className="buttons">
                    {/* <button className="btn-dark">Find a Co-Founder</button> */}
                    <br></br>
                    <button
                        className="btn-orange"
                        onClick={() => window.open("https://forms.gle/2ewkTW56QUAMHY1g9", "_blank")}
                    >
                        Apply Now
                    </button>
                    <button
                        className="btn-outline"
                        onClick={() => window.open("https://docs.google.com/forms/d/e/1FAIpQLSdTnm36GKeqRzS8iAByhJRyN6Z0jpbpOPUWsjU4ouR7nVidcQ/viewform?usp=sharing", "_blank")}
                    >
                        Join as an Advisor
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Hero;